export const getProductsRate = (payload?: any) => ({
    type: "@saga/GET_PRODUCTS_RATE",
    payload
});

